import { and, count, menu_product, type PowerSyncDrizzleDB } from "@comandero/powersync";
import { liveMenuProductFilters } from "./filters";

/**
 * Cuenta los productos de catálogo VIVOS del SQLite local. Alimenta
 * `checkUnsyncedActor` (prompt «¿conservar datos locales?» al migrar de invitado
 * a cuenta real): antes hacía `count() from(menu_product)` CRUDO en
 * `auth/controllers.ts`, contando también los de la papelera (bug de invariante
 * disperso — un producto borrado disparaba el prompt de "tienes datos locales").
 * Vía la capa live sólo cuenta vivos (y excluye los de una categoría en papelera,
 * por la cohorte de `liveMenuProductFilters`) — coherente con el resto de vistas.
 * (El merge invitado→real corre igualmente vía `sweepVisitorData`, así que
 * ninguna fila se pierde; este contador sólo decide si se MUESTRA el prompt.)
 */
export function getLiveMenuProductCountForUserQuery(db: PowerSyncDrizzleDB) {
  return db
    .select({ total: count() })
    .from(menu_product)
    .where(and(...liveMenuProductFilters()));
}
